import React from 'react'
import { Link } from 'react-router-dom';
import classes from './Tabs.module.css';

function Tabs(props) {
  return (
    <div className={classes.sec_tabs}>
        <ul className="nav nav-tabs-line">
            <li className={`${classes.tab} ${props.active === 'share' && classes.active}`}><Link to="/share"><i className="fa-brands fa-youtube"></i>Share video</Link></li>
            <li className={`${classes.tab} ${props.active === 'addvideo' && classes.active}`}><Link to="/add-video"><i className="fa-solid fa-cloud-arrow-up"></i>Upload video</Link></li>
            <li className={`${classes.tab} ${props.active === 'addmusic' && classes.active}`}><Link to="/add-music"><i className="fa-solid fa-file-audio"></i>Upload music</Link></li>
            <li className={`${classes.tab} ${props.active === 'addimage' && classes.active}`}><Link to="/add-image"><i className="fa-solid fa-image"></i>Upload a picture</Link></li>
            <li className={`${classes.tab} ${props.active === 'addwebgroup' && classes.active}`}><Link to="/add-web-group"><i className="fa-solid fa-square-up-right"></i>Add web groups</Link></li>
            <li className={`${classes.tab} ${props.active === 'addweblink' && classes.active}`}><Link to="/add-weblink"><i className="fa-solid fa-link"></i>Add web links</Link></li>
        </ul>
    </div>
  )
}

export default Tabs